"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Flex = styled_components_1.styled.div `
  background: ${(props) => props.darken
    ? "rgba(0,0,0,0.1)"
    : props.lighten
        ? "rgba(255, 255, 255, 0.05)"
        : null};
  position: ${(props) => (props.relative ? "relative" : "auto")};
  display: ${(props) => (props.notParent ? "block" : "flex")};
  flex-direction: ${(props) => (props.col ? "column" : "row")};
  align-items: ${(props) => props.align || "stretch"};
  justify-content: ${(props) => props.justify || "flex-start"};
  flex-wrap: ${(props) => (props.noWrap ? "nowrap" : "wrap")};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  flex: ${(props) => props.noResize ? "0 0 auto" : props.noGrow ? "0 1 auto" : props.flex};
  overflow: ${(props) => { var _a; return props.noOverflow ? "hidden" : ((_a = props.overflow) !== null && _a !== void 0 ? _a : "visible"); }};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border-radius: ${(props) => (props.rounded ? props.theme.radius : 0)};
`;
exports.default = Flex;
Flex.defaultProps = {
    notParent: false,
    col: false,
    align: "stretch",
    justify: "flex-start",
    noWrap: false,
    noResize: false,
    noGrow: false,
    flex: "1 1 auto",
    noOverflow: false,
    overflow: undefined,
    relative: false,
    style: {},
    padding: "0",
    margin: "0",
    darken: false,
    lighten: false,
    rounded: false,
};
//# sourceMappingURL=Flex.js.map